// extracted by mini-css-extract-plugin
export default {"btn":"TimeSelectDTSE_btn__Nvhpp","click":"TimeSelectDTSE_click__HaFBU"};